const buttonClasses = {
  lightGreen:"bg-[#9B9B9B] text-[#FFF] rounded-md hover:bg-[#B5B2B2]",
  darkGreen:"bg-[#187733] text-[#FFF] rounded-md hover:bg-[#1F803A]",
  lightBlue:"bg-[#005BBF] text-[#FFF] rounded-md hover:bg-[#1E3784]",
  transparent: "",
};

export default buttonClasses;
